<template>
    <div>
        <div class="">
            <error-messages :errors="errors" />

            <div class="">
                <div class="p-3 bg-light rounded">
                    <div class="font-weight-bold">
                        Escolha seu Plano
                    </div>

                    <hr>

                    <div>
                        <div v-for="(plan, planIdx) in form" :key="planIdx">
                            <div v-if="plan.type === 'unit'">
                                <b-form-group>
                                    <b-form-checkbox
                                        :id="`plan-${planIdx}`"
                                        v-model="plan.checked"
                                        :unchecked-value="false"
                                    >
                                        {{ plan.name }}
                                    </b-form-checkbox>
                                </b-form-group>
                            </div>
                            <div v-if="plan.type === 'volume'">
                                <b-form-group :label="plan.name">
                                    <b-form-input
                                        :id="`plan-${planIdx}`"
                                        v-model="plan.quantity"
                                        type="number"
                                        :placeholder="plan.name"
                                        :min="1"
                                    />

                                    <div class="p-1 small">
                                        <div v-for="(option, optionIdx) in plan.options" :key="optionIdx">
                                            De <b>{{ option.start_quantity }}</b> até <b>{{ option.end_quantity }}</b> custa <b>{{ formatPrice(option.price) }}</b> por unidade.
                                        </div>
                                        <div>
                                            Acima dessas quantidades, custa <b>{{ formatPrice(plan.overage_price) }}</b> por unidade.
                                        </div>
                                    </div>
                                </b-form-group>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div class="mt-4">
                <div class="p-3 bg-light rounded">
                    <div class="font-weight-bold mb-2">
                        Resumo da Assinatura
                    </div>

                    <hr>

                    <resume-subscription v-if="resume.length > 0" :resume="resume" />

                    <div v-else class="p-3 text-center">
                        Escolha seu plano ao lado para ver o resumo da assinatura :)
                    </div>
                </div>
            </div>

            <div class="mt-4 d-flex">
                <b-button @click="submit" primary :disabled="loading">
                    <span v-if="subscription">
                        Alterar Assinatura
                    </span>

                    <span v-else>
                        Assinar
                    </span>
                </b-button>

                <b-button @click="$emit('cancel')" variant="outline-default" :disabled="loading" class="ml-2">
                    Voltar
                </b-button>
            </div>
        </div>
    </div>
</template>

<script>
import plans from './mixins/plans';
import price from "./mixins/price";
import subscription from "./mixins/subscription";
import ErrorMessages from "../components/ErrorMessages.vue";
import ResumeSubscription from "../components/ResumeSubscription.vue";

export default {
    mixins: [plans, price, subscription],
    components: {
        ResumeSubscription,
        ErrorMessages
    },
    data() {
        return {
            loading: false,
            errors: {},
            form: []
        }
    },
    async created() {
        await this.loadSubscription()
        let plans = await this.loadPlans();

        if (this.subscription) {
            this.form = this.preparePlanWithSubscription(plans, this.subscription)
        } else {
            this.form = await this.loadPlans();
        }
    },
    computed: {
        resume() {
            return this.calculeResume(this.form)
        }
    },
    methods: {
        async submit() {
            if (this.subscription && this.subscription.status != 'canceled') {

                let subscriptionActualPriceTotal = this.calculeTotalAmount(this.subscription.items, false)
                let subscriptionNewPriceTotal = this.calculeTotalAmount(this.form)
                let diff = subscriptionNewPriceTotal - subscriptionActualPriceTotal

                if (diff > 0) {
                    await this.$bvModal.msgBoxConfirm('Iremos gerar uma fatura com o valor de ' + this.formatPrice(diff) + ' para cobrir o valor adicional. Deseja continuar ?', {
                        title: 'Atualizar Assinatura',
                        size: 'md',
                        buttonSize: 'sm',
                        okVariant: 'primary',
                        okTitle: 'Sim',
                        cancelTitle: 'Não',
                        cancelVariant: 'outline-default',
                        footerClass: 'p-2',
                        hideHeaderClose: false,
                        centered: true
                    }).then(async value => {
                        if (value) {
                            await this.updateSubscription(this.form)
                        }
                    }).catch(err => {
                        this.$toast.error('Ocorreu um erro ao atualizar a assinatura! Entre em contato com o suporte.');
                    })
                } else {
                    await this.updateSubscription(this.form)
                }
            } else {
                await this.createSubscription(this.form)
            }
        },

        async createSubscription(form) {
            this.loading = true;

            await axios.post('/teacher/pagarme/subscription', form)
                .then(async () => {

                    this.$emit('updated');

                    this.$toast.success('Assinatura realizada com sucesso!');

                    // Clear Errors
                    this.errors = {}
                })
                .catch((errors) => {
                    // Check Errors
                    this.errors = this.setErrors(errors)
                })
                .finally(() => this.loading = false)
        },

        async updateSubscription(form) {
            this.loading = true;

            await axios.put('/teacher/pagarme/subscription', form)
                .then(async () => {

                    this.$emit('updated');

                    this.$toast.success('Assinatura atualizada com sucesso!');

                    // Clear Errors
                    this.errors = {}
                })
                .catch((errors) => {
                    // Check Errors
                    this.errors = this.setErrors(errors)
                })
                .finally(() => this.loading = false)
        },
    }
}
</script>

<style scoped>

</style>
